import React from 'react';

const Footer = props => (
  <div className="">
  </div>
);

export default Footer;
